import * as net from 'util/Net';

export function runAlphaFold(proteinId: string): Promise<void> {
  return net.postJSONPromise({url: '/1/api/proteins:alphafold', data: {proteinId}});
}

export function runStructurePrediction(
  proteinIds: Array<string>,
  moleculeIds: Array<string>,
  model: string
): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/proteins:structure-prediction',
    data: {proteinIds, moleculeIds, model},
  });
}
